/** Keep the real project URL/storage key, while moving browser HTTP traffic to Pages. */
export function proxySupabaseUrl(url: string, projectUrl: string, origin: string): string {
  const target = new URL(url);
  if (target.origin !== new URL(projectUrl).origin) return url;
  return `${origin}/api/supabase${target.pathname}${target.search}${target.hash}`;
}

// Never pass a Request with a body as another Request's init: that copies its body as a stream, and older
// Chrome/WebView (seen on Chrome 124) rejects it without `duplex`. supabase-js sends auth calls as a URL and
// a plain init, but database queries and RPCs as a Request, so that body is read and sent as bytes instead.
export function supabaseFetch(projectUrl: string, origin: string, transport: typeof fetch = fetch): typeof fetch {
  return async (input, init) => {
    if (!(input instanceof Request)) {
      const url = input instanceof URL ? input.href : input;
      return transport(new Request(proxySupabaseUrl(url, projectUrl, origin), init));
    }
    const request = init ? new Request(input, init) : input;
    const url = proxySupabaseUrl(request.url, projectUrl, origin);
    if (url === request.url) return transport(request);
    const body = request.method === 'GET' || request.method === 'HEAD' ? undefined : await request.arrayBuffer();
    return transport(
      new Request(url, {
        method: request.method,
        headers: request.headers,
        body,
        signal: request.signal,
        credentials: request.credentials,
        cache: request.cache,
        redirect: request.redirect,
      }),
    );
  };
}
